/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { SmsRouteDto } from '../model/smsRouteDto';
import { SmsRouteModel } from '../model/smsRouteModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RouteCreationService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiRouteCreationDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiRouteCreationDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiRouteCreationDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/RouteCreation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param aggregatorId 
     * @param country 
     * @param countryCode 
     * @param mnc 
     * @param mcc 
     * @param host 
     * @param port 
     * @param routeName 
     * @param id 
     * @param operatorCode 
     * @param routeGroupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationDetailGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, routeName?: string, id?: string, operatorCode?: string, routeGroupId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteModel>;
    public apiRouteCreationDetailGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, routeName?: string, id?: string, operatorCode?: string, routeGroupId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteModel>>;
    public apiRouteCreationDetailGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, routeName?: string, id?: string, operatorCode?: string, routeGroupId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteModel>>;
    public apiRouteCreationDetailGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, routeName?: string, id?: string, operatorCode?: string, routeGroupId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }
        if (country !== undefined && country !== null) {
            queryParameters = queryParameters.set('country', <any>country);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('countryCode', <any>countryCode);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (host !== undefined && host !== null) {
            queryParameters = queryParameters.set('host', <any>host);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (routeName !== undefined && routeName !== null) {
            queryParameters = queryParameters.set('routeName', <any>routeName);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (operatorCode !== undefined && operatorCode !== null) {
            queryParameters = queryParameters.set('operatorCode', <any>operatorCode);
        }
        if (routeGroupId !== undefined && routeGroupId !== null) {
            queryParameters = queryParameters.set('RouteGroupId', <any>routeGroupId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmsRouteModel>('get',`${this.basePath}/api/RouteCreation/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsrouteName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationDetailSmsrouteNameGet(smsrouteName: string, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteModel>;
    public apiRouteCreationDetailSmsrouteNameGet(smsrouteName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteModel>>;
    public apiRouteCreationDetailSmsrouteNameGet(smsrouteName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteModel>>;
    public apiRouteCreationDetailSmsrouteNameGet(smsrouteName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (smsrouteName === null || smsrouteName === undefined) {
            throw new Error('Required parameter smsrouteName was null or undefined when calling apiRouteCreationDetailSmsrouteNameGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmsRouteModel>('get',`${this.basePath}/api/RouteCreation/detail/${encodeURIComponent(String(smsrouteName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param aggregatorId 
     * @param country 
     * @param countryCode 
     * @param mnc 
     * @param mcc 
     * @param host 
     * @param port 
     * @param operatorCode 
     * @param routeGroupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationDetailsGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, operatorCode?: string, routeGroupId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsRouteModel>>;
    public apiRouteCreationDetailsGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, operatorCode?: string, routeGroupId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsRouteModel>>>;
    public apiRouteCreationDetailsGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, operatorCode?: string, routeGroupId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsRouteModel>>>;
    public apiRouteCreationDetailsGet(aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, operatorCode?: string, routeGroupId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }
        if (country !== undefined && country !== null) {
            queryParameters = queryParameters.set('country', <any>country);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('countryCode', <any>countryCode);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (host !== undefined && host !== null) {
            queryParameters = queryParameters.set('host', <any>host);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (operatorCode !== undefined && operatorCode !== null) {
            queryParameters = queryParameters.set('operatorCode', <any>operatorCode);
        }
        if (routeGroupId !== undefined && routeGroupId !== null) {
            queryParameters = queryParameters.set('RouteGroupId', <any>routeGroupId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SmsRouteModel>>('get',`${this.basePath}/api/RouteCreation/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationGetByIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteModel>;
    public apiRouteCreationGetByIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteModel>>;
    public apiRouteCreationGetByIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteModel>>;
    public apiRouteCreationGetByIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmsRouteModel>('get',`${this.basePath}/api/RouteCreation/getById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationPost(body?: SmsRouteDto, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteModel>;
    public apiRouteCreationPost(body?: SmsRouteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteModel>>;
    public apiRouteCreationPost(body?: SmsRouteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteModel>>;
    public apiRouteCreationPost(body?: SmsRouteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmsRouteModel>('post',`${this.basePath}/api/RouteCreation`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationPut(body?: SmsRouteModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiRouteCreationPut(body?: SmsRouteModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiRouteCreationPut(body?: SmsRouteModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiRouteCreationPut(body?: SmsRouteModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/RouteCreation`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param aggregatorId 
     * @param country 
     * @param countryCode 
     * @param mnc 
     * @param mcc 
     * @param host 
     * @param port 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCreationServiceProvidersRouteGet(serviceProviderId?: string, aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsRouteModel>>;
    public apiRouteCreationServiceProvidersRouteGet(serviceProviderId?: string, aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsRouteModel>>>;
    public apiRouteCreationServiceProvidersRouteGet(serviceProviderId?: string, aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsRouteModel>>>;
    public apiRouteCreationServiceProvidersRouteGet(serviceProviderId?: string, aggregatorId?: string, country?: string, countryCode?: string, mnc?: string, mcc?: string, host?: string, port?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }
        if (country !== undefined && country !== null) {
            queryParameters = queryParameters.set('country', <any>country);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('countryCode', <any>countryCode);
        }
        if (mnc !== undefined && mnc !== null) {
            queryParameters = queryParameters.set('mnc', <any>mnc);
        }
        if (mcc !== undefined && mcc !== null) {
            queryParameters = queryParameters.set('mcc', <any>mcc);
        }
        if (host !== undefined && host !== null) {
            queryParameters = queryParameters.set('host', <any>host);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SmsRouteModel>>('get',`${this.basePath}/api/RouteCreation/serviceProvidersRoute`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
